import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isEcomEmail(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.ECOM_EMAIL && typeof label === 'string' && typeof value === 'string';
}
function _formatEcomEmail(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatEcomEmail(submission) {
  if (isEcomEmail(submission)) {
    return _formatEcomEmail(submission);
  }
  return undefined;
}
//# sourceMappingURL=ecom-email-preview.js.map